import CardTitle from '@/ui/title/Title';
import { useSelector } from 'react-redux';
import VerticalNewsFrame from '@/ui/card/newsCards/verticalFrame/VerticalNewsFrame';
import { useTranslation } from 'react-i18next';
import Nodata from '@/ui/errorSigns/noData/Nodata';

interface EsgTopicNewsProps {
  topics?: any[];
  navigateToESG?: () => void;
  sx?: any;
}

const EsgTopicNews = ({ topics = [], navigateToESG, sx }: EsgTopicNewsProps) => {
  const language = useSelector((state: any) => state.user.language);
  const [t] = useTranslation('news');
  const [dT] = useTranslation('noData');

  return (
    <div style={{ ...sx }}>
      <CardTitle title={t('ESG Topics')} more={t('More')} onClick={navigateToESG} />
      {topics.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {topics.map((topic, i) => (
            <div key={i} className="w-full md:w-fit">
              <VerticalNewsFrame
                title={topic[`general_issue_name_${language}`]}
                articles={topic.articles}
              />
            </div>
          ))}
        </div>
      ) : (
        <div>
          <Nodata desc={dT('No ESG news.')} className="w-[100px]" />
        </div>
      )}
    </div>
  );
};

export default EsgTopicNews;
